

/**
 * 이 라우터는 Main 의 하위 라우터입니다.
 *
 * 로그인 전과 로그인 후의 라우터를 분기합니다.
 */
const WelcomeRouter = [
    /**
     * 웰컴(로그인 페이지로 리디텍션)
     */
    {
        path: "/welcome",
        redirect: {name: "welcome.login"}
    },
    // 로그인
    {
        path: "/welcome/login",
        name: "welcome.login",
        component: () => import(/* webpackChunkName: "welcome" */ '../views/welcome/login/Login'),
    },
]

export default WelcomeRouter;